module.exports = __webpack_public_path__ + "static/img/buy_chance_photo.8ea58f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/buy_more/buy_chance_photo.png
// module id = eQMv
// module chunks = 1